import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '@/actions/user';
import { useMedia } from 'react-use';
import useUser from '@/hooks/useUser';
import MenuTaxonomyListItem from '@/components/menus/MenuTaxonomyListItem';
import { useUiStatus } from '@/hooks/useUiStatus';
import { favoritePost } from '@/domains/firestore/user';
import { IMenu } from '@/@types/generated/contentful';

type ComponentProps = {
  menu: IMenu;
};

const MenuTaxonomyListItemContainer: React.FC<ComponentProps> = ({ menu }) => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { setModalState } = useUiStatus();
  const isSp = useMedia('(max-width: 640px)');
  const user = useUser();
  const isFavorite = !!user?.favorited?.includes(menu.fields.id);
  const handleRequestUpdateFavorite = useCallback(
    async (postId: string) => {
      if (!user) {
        setModalState(true);
      } else {
        setLoading(true);
        await favoritePost({ userId: user.uid, postId });
        await dispatch(updateUser(user.uid));
        setLoading(false);
      }
    },
    [dispatch, setModalState, user]
  );
  return (
    <MenuTaxonomyListItem
      menu={menu}
      onRequestUpdateFavorite={handleRequestUpdateFavorite}
      isFavorite={isFavorite}
      isSp={isSp}
      invalid={isLoading}
    />
  );
};

export default MenuTaxonomyListItemContainer;
